import type { C1_State } from "./C1_State";
import type { State } from "../../../src/State";

type C1StateFactory = (appState: State) => C1_State;

let c1StateFactory: C1StateFactory | undefined;

/** Registers the concrete C1 state without adding it to the main State module graph. */
export function registerC1StateFactory(factory: C1StateFactory): void {
  c1StateFactory = factory;
}

/** Creates the single C1 state owned by a main application State. */
export function createC1State(appState: State): C1_State {
  if (!c1StateFactory) throw new Error("C1 state factory is not registered");
  return c1StateFactory(appState);
}

/** Temporary compatibility facade while callers migrate to `state.c1`. */
export const c1_state = new Proxy({} as C1_State, {
  get(_target, property) {
    const target = globalThis.state.c1;
    const value = Reflect.get(target, property, target);
    return typeof value === "function" ? value.bind(target) : value;
  },
  set(_target, property, value) {
    const target = globalThis.state.c1;
    return Reflect.set(target, property, value, target);
  },
});
